export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const VERIFY_REQUEST = 'VERIFY_REQUEST';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_ERROR = 'VERIFY_ERROR';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_ERROR = 'GET_USER_ERROR';
export const RESET_USER = 'RESET_USER';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const GET_PROFILE_QUESTION_REQUEST = 'GET_PROFILE_QUESTION_REQUEST';
export const GET_PROFILE_QUESTION_SUCCESS = 'GET_PROFILE_QUESTION_SUCCESS';
export const GET_PROFILE_QUESTION_ERROR = 'GET_PROFILE_QUESTION_ERROR';

export const ANSWER_REQUEST = 'ANSWER_REQUEST';
export const ANSWER_SUCCESS = 'ANSWER_SUCCESS';
export const ANSWER_ERROR = 'ANSWER_ERROR';

export const RESET_BLOCK = 'RESET_BLOCK';

export const LOGOUT = 'LOGOUT';

const block = {
  loading: false,
  success: false,
  error: null,
};

const initialState = {
  login: { ...block },
  verify: { ...block },
  resetPassword: { ...block },
  userInfo: { ...block, loading: !!localStorage.getItem('access'), info: null },
  updateInfo: { ...block },
  profileQuestion: { ...block, questions: [] },
  answerQuestion: { ...block },
};

export const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, login: { ...state.login, loading: true } };
    case LOGIN_SUCCESS:
      return {
        ...state,
        login: { ...state.login, loading: false, success: true, error: null },
      };
    case LOGIN_ERROR:
      return {
        ...state,
        login: { ...state.login, loading: false, error: action.error },
      };
    case VERIFY_REQUEST:
      return { ...state, verify: { ...state.verify, loading: true } };
    case VERIFY_SUCCESS:
      return {
        ...state,
        verify: { ...state.verify, loading: false, success: true, error: null },
      };
    case VERIFY_ERROR:
      return {
        ...state,
        verify: { ...state.verify, loading: false, error: action.error },
      };
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPassword: { ...state.resetPassword, loading: true },
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          loading: false,
          success: true,
          error: null,
        },
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          loading: false,
          error: action.error,
        },
      };
    case GET_USER_REQUEST:
      return {
        ...state,
        userInfo: { ...state.userInfo, loading: true, success: false },
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          info: { ...action.info, ...action.info.employee },
          loading: false,
          success: true,
          error: null,
        },
      };
    case GET_USER_ERROR:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          loading: false,
          error: action.error,
        },
      };
    case RESET_BLOCK:
      return { ...state, [action.block]: { ...state[action.block], ...block } };

    case RESET_USER:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          loading: false,
          success: false,
          error: null,
        },
      };
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        updateInfo: { ...state.updateInfo, loading: true },
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          info: { ...state.userInfo.info, ...action.info },
        },
        updateInfo: {
          ...state.updateInfo,
          loading: false,
          success: true,
          error: null,
        },
      };
    case UPDATE_USER_ERROR:
      return {
        ...state,
        updateInfo: {
          ...state.updateInfo,
          loading: false,
          error: action.error,
        },
      };
    case LOGOUT:
      return {
        login: { ...block },
        verify: { ...block },
        resetPassword: { ...block },
        userInfo: { ...block, loading: false, info: null },
        updateInfo: { ...block },
      };
    case GET_PROFILE_QUESTION_REQUEST:
      return {
        ...state,
        profileQuestion: {
          ...state.profileQuestion,
          loading: true,
          success: false,
        },
      };
    case GET_PROFILE_QUESTION_SUCCESS:
      return {
        ...state,
        profileQuestion: {
          ...state.profileQuestion,
          questions: action.info,
          loading: false,
          success: true,
          error: null,
        },
      };
    case GET_PROFILE_QUESTION_ERROR:
      return {
        ...state,
        profileQuestion: {
          ...state.profileQuestion,
          loading: false,
          error: action.error,
        },
      };
    case ANSWER_REQUEST:
      return {
        ...state,
        answerQuestion: {
          ...state.answerQuestion,
          loading: true,
          success: false,
        },
      };
    case ANSWER_SUCCESS:
      return {
        ...state,
        answerQuestion: {
          ...state.answerQuestion,
          loading: false,
          success: true,
          error: null,
        },
      };
    case ANSWER_ERROR:
      return {
        ...state,
        answerQuestion: {
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};
